








































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { Chapter } from 'frontend/types';
import Lesson from 'frontend/views/courses/CoursePage/components/Lesson.vue';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';
import ChapterAdmin from 'frontend/views/courses/CoursePage/components/ChapterAdmin.vue';

@Component({
  components: { ChapterAdmin, BriocheBackgroundImage, Lesson },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class ChaptersList extends Vue {
  @Prop({ type: Array, required: true })
  private chapters!: Chapter[];
  @Prop({ type: Number, required: true })
  private courseId!: number;
  @Prop({ type: String, required: true })
  private courseVersionName!: string;
  @Prop({ type: String, default: null })
  private recommendedSlug?: string;
  @Prop({ type: Boolean, default: false })
  private disableAutoScroll!: boolean;
  @Prop({ type: String, default: null })
  private previousLessonSlug?: string;

  mounted(): void {
    this.scrollToRecommendedChapterIfNeeded();
  }

  private scrollToRecommendedChapterIfNeeded(): void {
    // reset scroll to top of page, Vue scrollBehavior used to handle this
    // but we want to handle scrolling ourselves on this page
    window.scroll({ top: 0 });

    if (!this.disableAutoScroll) {
      const recommendedChapterIndex = this.recommendedSlug
        ? this.chapters.findIndex(chapter =>
            chapter.quizzes.some(lesson => lesson.slug === this.recommendedSlug),
          )
        : -1;

      if (recommendedChapterIndex !== -1) {
        // Disable default scrolling behavior for this page to prevent jumps and allow the scrolling
        // to the recommended chapter. This setting does not affect other pages in our application.
        // Some lines below the default scrolling behavior is restored if we don't have a recommended chapter.
        window.history.scrollRestoration = 'manual';

        const recommendedChapter = (this.$refs.chapters as Element[])[recommendedChapterIndex];
        const chapterFitsInScreen =
          recommendedChapter.getBoundingClientRect().height < window.innerHeight * 0.8;

        if (chapterFitsInScreen) {
          const expectedPixelsBetweenChapterAndScreenTop = 137;
          const pixelsToScroll =
            document.documentElement.scrollTop +
            recommendedChapter.getBoundingClientRect().top -
            expectedPixelsBetweenChapterAndScreenTop;

          window.scroll({ left: 0, top: pixelsToScroll, behavior: 'smooth' });
        } else {
          const recommendedLesson = recommendedChapter.querySelector('.lesson.is-recommended');

          if (recommendedLesson) {
            recommendedLesson.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      } else {
        window.history.scrollRestoration = 'auto';
      }
    }
  }
}
